import { createSlice } from '@reduxjs/toolkit';
import { IPopularOutcomes, popularOutcomesApi } from './popularOutcomesApi';

const initialState: { data: IPopularOutcomes } = {
  data: {},
};

const popularOutcomesSlice = createSlice({
  name: 'popularOutcomes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(popularOutcomesApi.endpoints.getPopularOutcomes.matchFulfilled, (state, { payload, meta }) => {
      String(meta.arg.originalArgs).split(',').forEach((eventId) => {
        const popular = payload?.[eventId];
        if (popular && typeof popular === 'object' && Object.keys(popular).length) {
          state.data[eventId] = popular;
        } else {
          delete state.data[eventId];
        }
      });
    });
  },
});

export default popularOutcomesSlice.reducer;
